<template>
  <div id="app">
    <router-view name="header" />
    
    <router-view/>
      
    <router-view name="footer" />
  </div>
</template>

<script>

export default {
  name: 'App',
  data(){return {
    darkMode : false
  }},
  created() {
    this.darkMode = window.matchMedia("(prefers-color-scheme:dark)").matches;
  },
  methods: {
  },
  computed: {
    preferDarkMode() {
      return window.matchMedia("(prefers-color-scheme:dark)").matches;
    }
  }
}
</script>

<style lang="scss">
  html {
    scroll-behavior: smooth!important;
  }

  /* Dark mode */
  @media (prefers-color-scheme: dark) {
    .theme-font {
      color: white!important;
    }
    .theme-background {
      background-color: #000000!important;
    }
  }

  .terms {
    margin-top: 32px;
    
    .title {
      font-weight: bold !important;
      margin-bottom: 8px;
      margin-top: 32px;
    }
  }


body h1,
body h2,
body h3,
body h4,
body h5,
body label,
body span,
body p {
  font-weight: 300!important;
}

.biggerLogo {
  width: 60%;
  max-width: 60vh;
  opacity: 1;
  animation: fadeIn 2s ease;
  -webkit-animation-delay: 0.2s;
  -moz-animation-delay: 0.2s;
  animation-delay: 0.2s;
  z-index: 3;
}

.logo-container {
  background: rgba(0,0,0,0);
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
}

@-webkit-keyframes fadeIn { 0% { opacity:0; } 100% { opacity:1; } }
@-moz-keyframes fadeIn { 0% { opacity:0; } 100% { opacity:1; } }
@keyframes fadeIn { 0% { opacity:0; } 100% { opacity:1; } }


.page-header.bigger-video::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: linear-gradient(to right,#0375b8,#dc6e25);
  opacity: 0.5; 
  z-index: 2;
}

.game {
  margin-top: 48px;
  width: 100%;
  height: 100%;
  position: relative;
}

.game .game-icon {
    transition: 0.5s;
    align-self: center;
    width: 180px;
    border-radius: 180px;
}

.games > .game-col {
  margin-bottom: 32px;
}

.game-info {
  width: inherit;
  height: inherit;
  /* top: 17%; */
  // position: absolute;
  border-radius: 16px;
  transition: 0.25s;
  opacity: 1;
  /* background-image: linear-gradient(to bottom, #ffffff00,#00000099,#ffffff00); */
  /* background-color: rgba(0, 0, 0, 0.5); */
  text-align: center;
  display: flex;
  flex-direction: column;
  align-content: center;
}

// .game:hover > .game-info {
//    opacity: 0.1; 
// }

.badges {
  margin-top: 32px;
  transition: 0.5s;
}

.game:hover .badges  {
  transform: scale(1.1);
}

.game:hover .game-icon  {
  transform: scale(1.1);
}

.game-info > .title {
  font-weight: bolder;
  margin-top: 16px;
  text-align: center;
  // color: white;
}

.game-info > .desc {
  margin: auto!important;
  text-align: center;
}

.game-info .download {
  margin-top: 0px;
  font-weight: 100;
  text-align: center;
}

.store-badge {
  height: 40px;
}

.bigger-footer {
  padding-top: 12px;
}

/* .section.aboutus {
  background-image: linear-gradient(to bottom,#000000,#dc422500);
} */

.social-link {
  margin: 0!important;
}

.footer > .social-link {
  margin: 0!important;
} 

.social-link > a {
  font-size: 24px!important;
}

.section.join-us {
  z-index: 3;
}

.shadow-inset-top {
  -moz-box-shadow    : inset 0px 8px 20px 2px #131111;
  -webkit-box-shadow : inset 0px 8px 20px 2px #131111;
  box-shadow         : inset 0px 8px 20px 2px #131111;
}

.shadow-top {
  -moz-box-shadow    : 0px -5px 20px 0px #131111;
  -webkit-box-shadow : 0px -5px 20px 0px #131111;
  box-shadow         : 0px -5px 20px 0px #131111;
  z-index: 3;
}

.shadow-bottom {
  -moz-box-shadow    : 0px 6px 10px -2px #d2d0d078;
  -webkit-box-shadow : 0px 6px 10px -2px #d2d0d078;
  box-shadow         : 0px 6px 10px -2px #d2d0d078;
  z-index: 3;
}

.shadow-bottom-over-dark {
  -moz-box-shadow    : 0px 20px 20px 0px #0000007e;
  -webkit-box-shadow : 0px 20px 20px 0px #0000007e;
  box-shadow         : 0px 20px 20px 0px #0000007e;
  z-index: 3;
}

.shadow-vertical {
  -moz-box-shadow    : 0px 6px 20px 3px #d2d0d0;
  -webkit-box-shadow : 0px 6px 20px 3px #d2d0d0;
  box-shadow         : 0px 6px 20px 3px #d2d0d0;
  z-index: 3;
}

input[type="file"] {
  display: none;
}

form label.btn {
  font-weight: 600!important;
}

/* .page-header.bigger {
  background-image: url('../images/bg.jpg');
} */
</style>




// WEBPACK FOOTER //
// src/App.vue